export default __webpack_public_path__ + "static/poele-anthracite-c4101534e5a0f37ed9d8a786454d6c7a.jpg";